import React, { useMemo, useState } from 'react'
import moment from 'moment'
import { useHistory, useParams } from 'react-router-dom'
import BookingFooter from '../../../Share/Booking/BookingFooter/BookingFooter'
import { BookingMallDetailAPI } from '../../../../lib/mytable'
import { authorizationWithPrefix } from '../../../../lib/utils'
import { usePartnerContext } from '../../../../context/Common/partner'
import { useModalContext } from '../../../../context/Common/modal'
import { useFooter, useProvisionalReservation, useReservation, useTimer } from '../../../../store'

const won = value => `₩${value.toLocaleString('ko-KR')}`

// 예약 상품이 하나인 고정 일정 매장은 예약 상품 단계를 건너뛰고 가예약 후 정보 입력으로 이동
export default function FixedScheduleFooter({ schedule }) {
	const history = useHistory()
	const { mallUri } = useParams()
	const { apiKey } = usePartnerContext()
	const { alertOpen } = useModalContext()
	const { active } = useFooter()
	const { totalPartySize, dateTime, voucherData, setReservation, resetCategory, resetDetailPartySize } =
		useReservation()
	const { cancelReservation, setProvisionalReservation } = useProvisionalReservation()
	const { setTimer, resetTimer } = useTimer()
	const [isRequesting, setIsRequesting] = useState(false)
	const bookingMallDetailAPI = useMemo(
		() => new BookingMallDetailAPI(apiKey, authorizationWithPrefix()),
		[apiKey, voucherData]
	)

	const startProvisionalReservation = async () => {
		if (isRequesting)
			return
		setIsRequesting(true)
		try {
			await cancelReservation(apiKey, mallUri)
			resetCategory()
			resetTimer()
			resetDetailPartySize()
			sessionStorage.removeItem('selectedDate')

			const categories = await bookingMallDetailAPI.getCategories(mallUri, totalPartySize, dateTime)
			const category = categories?.list?.find(item => item.reservable)
			if (!category)
				throw new Error('현재 예약 가능한 좌석이 없습니다.')
			setReservation('categoryId', category.category_id)

			const pre = await bookingMallDetailAPI.makeProvisionalReservation(
				mallUri,
				totalPartySize,
				dateTime,
				category.category_id
			)
			if (!pre.result)
				throw new Error(pre.message)
			setProvisionalReservation('reservationToken', pre.token)
			setReservation('deposit', pre.price)

			const started = await bookingMallDetailAPI.pretendProvisionalReservation(pre.token)
			setTimer('expire', moment(started.date_expire))
			sessionStorage.removeItem('visitedBookingPayment')

			history.push(`/booking/${mallUri}/step/detail-info?token=${pre.token}`)
			// 안내 금액과 매장 예약금 설정이 다르면 실제 결제 금액 안내 (alert 콜백은 즉시 실행되므로 이동 후 노출)
			if (pre.price !== schedule.unitPrice * totalPartySize)
				alertOpen(`결제 금액은 ${won(pre.price)}입니다.`, '확인')
		} catch (e) {
			resetCategory()
			alertOpen(e.message || '예약을 진행할 수 없습니다. 잠시 후 다시 시도해주세요.')
		} finally {
			setIsRequesting(false)
		}
	}

	return <BookingFooter text="다음" action={startProvisionalReservation} active={active && !isRequesting} />
}
